import React from 'react';

class StatisticalItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      percent: this.props.percent,
      fillColor: this.props.fillColor,
      value: this.props.value
    }
  }

  render() {
    return (
      <div className="statistical-item">
        <div className='statistical-item-background'>
          <div className='statistical-item-value' style={{height: + String(this.state.percent) + '%', backgroundColor: this.props.fillColor}}></div>
        </div>
        <div className='statistical-item-name'><span className='statistical-item-name-content'>{this.props.value}</span></div>
      </div>
    );
  }
}

StatisticalItem.defaultProps = {
  percent: 0,
  fillColor: '#fff',
  value: '1'
}

export default StatisticalItem;


// WEBPACK FOOTER //
// ./components/my-business/sub-view/the-news/statistical/StatisticalItem.jsx